/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Connect_Your_AppInputs */

const en_mcp_connect_your_app = /** @type {(inputs: Mcp_Connect_Your_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`your app`)
};

const es_mcp_connect_your_app = /** @type {(inputs: Mcp_Connect_Your_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tu app`)
};

/**
* | output |
* | --- |
* | "your app" |
*
* @param {Mcp_Connect_Your_AppInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_connect_your_app = /** @type {((inputs?: Mcp_Connect_Your_AppInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Connect_Your_AppInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_connect_your_app(inputs)
	return en_mcp_connect_your_app(inputs)
});